module.exports = __webpack_public_path__ + "static/media/DSC_0090.1b55aeb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0090.jpg
// module id = 555
// module chunks = 0